import { ref, computed } from '@vue/composition-api'

let store = {}
let module
const setupVerticalNavMenu = (clientStore, _module) => { // must run this on the client to setup store first!
  store = clientStore
  module = _module || 'hwUiMenu'
}

const useVerticalNavMenu = props => {
  const state = store.state[module]
  const mutations = {
    toggleCollapsed: 'hwUiMenu/UPDATE_VERTICAL_MENU_COLLAPSED'
  }

  const activeMenuItems = computed({
    get: () => state.activeMenuItems,
  })

  const isVerticalMenuCollapsed = computed({
    get: () => state.isVerticalMenuCollapsed,
    set: val => {
      store.commit(mutations.toggleCollapsed, val)
    },
  })

  // ------------------------------------------------
  // collapseTogglerIcon
  // ------------------------------------------------
  const collapseTogglerIcon = computed(() => {
    if (props.isVerticalMenuActive) {
      return isVerticalMenuCollapsed.value ? 'unpinned' : 'pinned'
    }
    return 'close'
  })

  const isMouseHovered = ref(false)

  const updateMouseHovered = val => {
    isMouseHovered.value = val
  }

  const toggleCollapsed = () => {
    isVerticalMenuCollapsed.value = !isVerticalMenuCollapsed.value
  }

  const switchLayout = () => {
    store.dispatch('updateLayoutAndMenu', {app: store.state.app.name, layout: 'horizontal'})
  }

  return {
    activeMenuItems,
    isMouseHovered,
    isVerticalMenuCollapsed,
    collapseTogglerIcon,
    toggleCollapsed,
    updateMouseHovered,
    switchLayout,
  }
}

export {
  setupVerticalNavMenu,
  useVerticalNavMenu
}